var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout } from "~/core/decorator";
import { OutsourceLawsuitService } from "~/services/domain-service/outsource-lawsuit-manage-index.service";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import CostMaintain from "~/components/outsource-manage/outsource-lawsuit-manage/cost-maintain.vue";
import LawsuitKind from "~/components/lawsuit-follow/lawsuit-kind.vue";
import LawsuitFollow from "~/components/lawsuit-follow/lawsuit-follow.vue";
import { MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
// @Auth(1011)
var OutsourceLawsuitManageIndex = /** @class */ (function (_super) {
    __extends(OutsourceLawsuitManageIndex, _super);
    function OutsourceLawsuitManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowData = {};
        _this.dataList = [];
        _this.selectionList = [];
        _this.isView = false;
        // form 查询表单参数
        _this.queryModel = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overduePeriod: "",
            overdueDays: {
                max: "",
                min: ""
            },
            productCategory: "",
            productName: "",
            labelName: ""
        };
        _this.dialog = {
            isOpenCostMaintenance: false,
            isOpenLawsuitKind: false,
            isOpenLawsuitFollow: false
        };
        return _this;
    }
    Object.defineProperty(OutsourceLawsuitManageIndex.prototype, "lawsuit", {
        get: function () {
            return {
                kind: this.rowData.lawsuitFollowType,
                status: this.rowData.lawerStatus
            };
        },
        enumerable: false,
        configurable: true
    });
    OutsourceLawsuitManageIndex.prototype.mounted = function () {
        this.refreshData();
    };
    OutsourceLawsuitManageIndex.prototype.refreshData = function () {
        var _this = this;
        this.outsourceLawsuitService
            .getCaseOutLawsuitList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) { return (_this.dataList = data); });
    };
    OutsourceLawsuitManageIndex.prototype.recycleCase = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要回收的案件");
            return;
        }
        var ids = this.selectionList.map(function (v) { return v.id; });
        this.outsourceLawsuitService.caseRecover({ ids: ids }).subscribe(function (data) {
            _this.$message.success(data);
            _this.refreshData();
        });
    };
    /**
     * 重置numberRange
     */
    OutsourceLawsuitManageIndex.prototype.follFeedback = function () {
        this.queryModel.outAmount = { min: "", max: "" };
        this.queryModel.overdueDays = { min: "", max: "" };
        this.queryModel.caseMoney = { min: "", max: "" };
    };
    /**
     * 点击诉讼跟进
     */
    OutsourceLawsuitManageIndex.prototype.lawsuitClick = function (rowData) {
        this.rowData = rowData;
        if (!rowData && rowData.assistStatus === "ASSIST_OVER") {
            this.$message.info("无诉讼跟进信息");
            return;
        }
        // 如果存在诉讼类型 跳过选择诉讼类型的一步
        if (!rowData.lawsuitFollowType) {
            this.dialog.isOpenLawsuitKind = true;
        }
        else {
            this.dialog.isOpenLawsuitFollow = true;
        }
    };
    /**
     * 进入查看执行页
     */
    OutsourceLawsuitManageIndex.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Outsource_lawsuit,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    __decorate([
        Dependencies(OutsourceLawsuitService)
    ], OutsourceLawsuitManageIndex.prototype, "outsourceLawsuitService", void 0);
    __decorate([
        Dependencies(PageService)
    ], OutsourceLawsuitManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OutsourceLawsuitManageIndex.prototype, "sortService", void 0);
    OutsourceLawsuitManageIndex = __decorate([
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                GetLabelName: GetLabelName,
                CostMaintain: CostMaintain,
                LawsuitKind: LawsuitKind,
                LawsuitFollow: LawsuitFollow
            }
        })
    ], OutsourceLawsuitManageIndex);
    return OutsourceLawsuitManageIndex;
}(Vue));
export default OutsourceLawsuitManageIndex;
